import { useState } from "react";
import useGameStore from "../../lib/store/GameStore";
import { BaseDialog } from "./BaseDialog";

function BigBashGridDialog({ modalTitle = "Take the Captains Challenge" }) {
  const [isOpen, setIsOpen] = useState(true);

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <BaseDialog
        dark={true}
        isOpen={isOpen}
        closeModal={closeModal}
        modalTitle=""
        modalBody={<ModalBody closeModal={closeModal} />}
        size="lg"
        showClose={false}
      />
    </>
  );
}

function ModalBody({ closeModal }) {
  return (
    <>
      <div className="text-md font-normal text-black sm:text-base">
        <div className="-mx-4 -mt-6 mb-4 flex items-center justify-center">
          <img
            className="mx-auto w-full"
            src={`/img/partners/bigbash/big-bash-landscape.jpg`}
            alt={`Play Finals Fantasy`}
          />
        </div>
        <h3 className="mb-4 text-center text-xl font-semibold dark:text-gray-400 sm:text-2xl">
          PLAY BIG BASH GRID
        </h3>
        {/*<div className="mb-4 px-2 text-black dark:text-gray-400">*/}
        {/*  Can you out-captain Calvin? Out-project Popowski?*/}
        {/*</div>*/}
        <div className="mb-6 px-2 text-center text-black dark:text-gray-400">
          Test your BBL knowledge with the arrival of{" "}
          <span className="font-semibold"> Big Bash Grid!</span> Download the
          Big Bash app for a new BBL and WBBL grid each day.
        </div>
        <div className="text-center">
          <a
            href="https://www.bigbash.com.au/big-bash-app?utm_source=gridley&utm_medium=affiliate&utm_campaign=launch-modal"
            target="_blank"
            className="mx-auto mb-2 inline-block rounded-lg bg-big-bash-yellow px-5  py-2 text-center  font-semibold text-black  disabled:opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Play Now →
          </a>
        </div>
      </div>
    </>
  );
}

export default BigBashGridDialog;
